import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCommodity } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetCommoditiesResponse = {
  commodityList: TMSCommodity[];
  tmsTenant: string;
  message: string;
};

export async function getCommodities(
  tmsID: number,
  forceRefresh?: boolean,
  changeHostName?: boolean,
  customerID?: number,
  carrierType?: number,
  externalTmsId?: string
): Promise<Result<GetCommoditiesResponse, ApiError>> {
  try {
    const queryParams = new URLSearchParams({
      tmsID: tmsID.toString(),
    });

    if (forceRefresh) {
      queryParams.append('forceRefresh', 'true');
    }

    if (changeHostName) {
      queryParams.append('changeHostName', 'true');
    }

    if (customerID) {
      queryParams.append('customerID', customerID.toString());
    }

    if (externalTmsId) {
      queryParams.append('externalTmsId', externalTmsId);
    }

    if (carrierType != null) {
      queryParams.append('carrierType', carrierType.toString());
    }

    const response = await axios.get<GetCommoditiesResponse>(
      `/commodities?${queryParams.toString()}`
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getCommodities' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get list of commodities from TMS' });
    }

    return err({
      message:
        error.response?.data?.message ||
        'Failed to get list of commodities from TMS',
      status: error.response?.status,
    });
  }
}
